export default __webpack_public_path__ + "static/media/rhea2.7e5d8074.png";